module.exports = __webpack_public_path__ + "static/img/goodsList1.d48aef6a.png";